import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { endpoints } from 'global/endpoints';
import { roles } from 'global/rolesAndPermissions';
import { routePaths } from 'global/routePaths';
import { useUserStore } from 'store/useUserStore';
import http from 'utils/http';
import toaster from 'utils/toaster';
import token from 'utils/token';

export const login = (postData: any) => {
  return http().post(endpoints.login, postData);
};

export function useLogin(searchParams: URLSearchParams) {
  const { t } = useTranslation(['common']);

  const navigate = useNavigate();
  const addUserDetails = useUserStore(state => state.addUserDetails);

  return useMutation({
    mutationFn: login,
    onSuccess: ({ payload }) => {
      const { apiToken, userUniqueToken, apiTokenExpiresAt, ...userData } = payload;
      token.setToken({ accessToken: apiToken, userUniqueToken: userUniqueToken, expiryDate: '' + apiTokenExpiresAt });
      addUserDetails(userData);

      const isCherryPick = searchParams.get('action') === 'pick';

      if (isCherryPick) {
        setTimeout(() => {
          navigate({ pathname: routePaths.cherryPickShift.base.route, search: searchParams.toString() });
        }, 0);
      } else {
        if (userData?.userInfo?.roleId === roles.EMPLOYEE) {
          setTimeout(() => {
            navigate(routePaths.employeeTimeClock.route);
          }, 0);
        } else {
          setTimeout(() => {
            navigate(routePaths.dashboard);
          }, 0);
        }
      }
    },
    onError: ({ message, error }) => {
      toaster.error({ description: message ?? error?.message ?? t('common:errorOccured') });
    },
  });
}
